export { default } from './AnimateScroll'
